import AppDataService from "./AppDataService";

const COMMON_BASE = "auth";

export default class ReportScreenService {
  static async getPatientListForReports(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      //`include=true`,
      data?.startDate ? `startDate=${data.startDate}` : "",
      data?.endDate ? `endDate=${data?.endDate}` : "",
      // data?.typeOfCare ? `typeofCare=${data.typeofCare}` : "",
      data?.visitType ? `visitType=${data.visitType}` : "",
      data?.status ? `status=${data?.status}` : "",
      data?.gender ? `gender=${data?.gender}` : "",
      data?.facilityId ? `facilityId=${data.facilityId}` : "",
      data?.isReport ? `isReport=${data.isReport}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    // return await AppDataService.get(`task${queryString}`);
    // Always skip the global facilityId interceptor for patient reports: when no
    // facility is selected in the report filter, no facilityId should be sent at
    // all; when one is selected it is already in the query string above.
    return await AppDataService.get(`patient${queryString}`, {
      skipFacilityId: true,
    });
  }
  static async getVisitListForReport(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      `include=true`,
      data?.startDate ? `startDate=${data.startDate}` : "",
      data?.endDate ? `endDate=${data?.endDate}` : "",
      data?.typeOfCare ? `typeofCare=${data.typeofCare}` : "",
      data?.type ? `type=${data.type}` : "",
      data?.status ? `status=${data?.status}` : "",
      data?.sign ? `sign=${data?.sign}` : "",
      data?.facilityId ? `facilityId=${data.facilityId}` : "",
      data?.isReport ? `isReport=${data.isReport}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    // return await AppDataService.get(`task${queryString}`);

    // Skip the global facilityId interceptor so the Facility filter (or "All
    // Facilities" = none) controls scope, matching the patient report.
    return await AppDataService.get(`visit${queryString}`, {
      skipFacilityId: true,
    });
  }
}
